<script setup lang="ts">
import UiChip from '../UiChip.vue'

interface Props {
    comboboxValue: string[]
    getLabel: (value: string) => string
}

defineProps<Props>()

const emit = defineEmits<{
    (e: 'remove', value: string): void
}>()
</script>

<template>
    <div 
        v-if="comboboxValue.length > 0"
        class="flex flex-wrap gap-2 mt-2"
    >
        <UiChip
            v-for="value in comboboxValue"
            :key="value"
            :text="getLabel(value)"
            variant="primary"
            size="sm"
            rounded="full"
            icon="close"
            @click="emit('remove', value)"
        />
    </div>
</template>

